// Time Machine — Internet Explorer's address bar actually browses, but through the Wayback Machine,
// so every site loads the way it looked in the year you pick. `if_` = Wayback's iframe mode (no toolbar,
// links rewritten so you keep browsing inside the frame). Nothing is proxied by us.
export const YEARS = [1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010];
export const DEFAULT_YEAR = 2003;

export const FAVORITES = [
  { name: 'Google', url: 'google.com', year: 2003, note: 'ten blue links. "i\'m feeling lucky."' },
  { name: 'Yahoo!', url: 'yahoo.com', year: 2001, note: 'the directory. the portal. the exclamation mark.' },
  { name: 'MSN', url: 'msn.com', year: 2002, note: 'the homepage IE shipped with.' },
  { name: 'AltaVista', url: 'altavista.com', year: 1999, note: 'the search engine before the search engine.' },
  { name: 'Ask Jeeves', url: 'askjeeves.com', year: 2001, note: 'you asked a butler. he tried.' },
  { name: 'Amazon', url: 'amazon.com', year: 2000, note: 'earth\'s biggest bookstore.' },
  { name: 'eBay', url: 'ebay.com', year: 2001, note: 'beanie babies at all-time highs.' },
  { name: 'Apple', url: 'apple.com', year: 2001, note: 'the ipod launch. 1,000 songs in your pocket.' },
  { name: 'Microsoft', url: 'microsoft.com', year: 2001, note: 'windows xp. "yes you can."' },
  { name: 'Nokia', url: 'nokia.com', year: 2002, note: 'the 3310 era. snake.' },
  { name: 'MySpace', url: 'myspace.com', year: 2006, note: 'tom is your friend. pick your top 8.' },
  { name: 'YouTube', url: 'youtube.com', year: 2006, note: '"broadcast yourself." before the algorithm.' },
  { name: 'Wikipedia', url: 'wikipedia.org', year: 2003, note: 'the free encyclopedia, 150,000 articles in.' },
  { name: 'Newgrounds', url: 'newgrounds.com', year: 2003, note: 'flash games. the portal. everything, by everyone.' },
  { name: 'Homestar Runner', url: 'homestarrunner.com', year: 2003, note: 'strong bad checks his email.' },
  { name: 'Hampster Dance', url: 'hampsterdance.com', year: 2000, note: 'the song. you can hear it already.' },
  { name: 'GeoCities', url: 'geocities.com', year: 2001, note: 'neighborhoods. under construction gifs. guestbooks.' },
  { name: 'Napster', url: 'napster.com', year: 2000, note: 'the whole music industry, on your dial-up.' },
  { name: 'AOL', url: 'aol.com', year: 2001, note: 'you\'ve got mail.' },
  { name: 'Slashdot', url: 'slashdot.org', year: 2001, note: 'news for nerds. stuff that matters.' },
  { name: 'CNN', url: 'cnn.com', year: 2001, note: 'the news, in 800×600.' },
  { name: 'NASA', url: 'nasa.gov', year: 2001, note: 'the iss was three years old.' },
  { name: 'Space Jam', url: 'spacejam.com', year: 1997, note: 'the 1996 site. never changed. a monument.' },
  { name: 'Bitcoin', url: 'bitcoin.org', year: 2009, note: 'the whitepaper era. "a peer-to-peer electronic cash system."' },
  { name: 'the internet webring', url: 'webring.internetcoin.vip', year: 0, note: 'the internal web. sites that only exist inside this computer.' },
];

// "google.com", "http://www.yahoo.com/foo" → "www.yahoo.com/foo" (Wayback wants the original scheme-less path)
export function normalizeUrl(input) {
  let s = String(input || '').trim();
  s = s.replace(/^[a-z]+:\/\//i, '');
  s = s.replace(/^\/+/, '');
  return s;
}

export const isHome = input => {
  const s = normalizeUrl(input).toLowerCase();
  return !s || /^(www\.)?internetcoin\.vip\/?$/.test(s) || s === 'home' || s === 'about:home';
};

// Wayback URL for a site in a given year. `if_` = iframe mode (no Wayback toolbar, links rewritten).
export const waybackUrl = (input, year) =>
  `https://web.archive.org/web/${year}0615000000if_/http://${normalizeUrl(input)}`;

export const wayback = (input, year) =>
  `https://web.archive.org/web/${year}0615000000/http://${normalizeUrl(input)}`; // with toolbar (Open in new window)
